// extracted by mini-css-extract-plugin
module.exports = {"iframe":"external-url-description-external-url-description-iframe-e9bf87f5","iframeWrapper":"external-url-description-external-url-description-iframeWrapper-ef0771a7"};